<template>
<div class="content-wrapper">
  <div class="side" style="#f0f2f4;">
    <div class="side-title">{{title}}</div>
    <el-menu v-if="menu !== null" mode="vertical" class="settings-sub-menu" :default-active="defaultActiveMenu" >
      <el-menu-item v-for="item in menu" :key="item.id" :index="item.id" @click="clickMenu(item)">
        {{item.name}}
      </el-menu-item>
    </el-menu>
  </div>
  <slot name="activeView"/>
  <!-- <div class="content-main">
    <el-scrollbar class="bar-visible">
      <div class="content">
          <slot class="setting-content" name="activeView"></slot>
      </div>
    </el-scrollbar>
  </div> -->
</div>
</template>

<script>
export default {
  name: 'WSettingsDetail',
  props: {
    title: String,
    menu: {
      type: Array,
      default: null,
    },
    defaultActiveMenu: String,
  },
  data() {
    return {
      activeView: null,
    };
  },
  methods: {
    clickMenu(menu) {
      this.activeView = menu.id;
      this.$emit('change', this.activeView);
    },
  },
};
</script>

<style lang="scss" scoped>
.el-scrollbar__view {
  min-height: 100%;
}
</style>



// WEBPACK FOOTER //
// src/components/template/SettingsDetail.vue